import { AuthenticationEnum } from '@/types/translations/AuthenticationEnum';

/**
 * Checks if a password meets the security criteria.
 * @param password - The password to validate.
 * @returns An object containing a boolean indicating validity and a string with the error message if invalid.
 */
function isPasswordValid(password: string):
  | {
      isValid: false;
      error: AuthenticationEnum;
    }
  | {
      isValid: true;
      error: null;
    } {
  const lengthRequirement = password.length >= 8;
  const lowerCase = /[a-z]/.test(password);
  const upperCase = /[A-Z]/.test(password);
  const numbers = /[0-9]/.test(password);
  const specialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (!lengthRequirement) {
    return {
      isValid: false,
      error: AuthenticationEnum.password_must_be_8_characters_long,
    };
  }

  const categoriesMet = [lowerCase, upperCase, numbers, specialChars].filter(
    Boolean
  ).length;

  if (categoriesMet < 3) {
    return {
      isValid: false,
      error: AuthenticationEnum.password_requeriments,
    };
  }

  return { isValid: true, error: null };
}

export { isPasswordValid };
